import { apiGet } from '.';
import { GoModule } from '@go-shared/types/go-modules/goModules';

export function getModules(): Promise<Array<GoModule>> {
  return apiGet('/modules');
}
